import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Trash2, PenLine } from "lucide-react";
import { useState } from "react";
import { toast } from "react-hot-toast";
import { DeleteConfirmDialog } from "@/components/dialog/staff-manage/all-staff-dialog";
import { useSelector } from "react-redux";
import { Switch } from "@/components/ui/switch";
import API from "@/api/lib/api";
import AddEditFloor from "./AddEditFloor";
import hasPermission from "@/hooks/hasPermission";

function FloorList({ data, onRefresh, formType, setFormType }) {
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [itemsDialog, setItemsDialog] = useState(null);

  const { deleteLoading, requestStatus, error } = useSelector(
    (state) => state.menuManage.drink
  );

  const [isSingleVoucherModalOpen, setIsSingleVoucherModalOpen] = useState(false);
  const closeSingleVoucher = () => {
    setIsSingleVoucherModalOpen(false); 
  };

  const closeDeleteDialog = () => {
    setDeleteDialog(false);
    setItemsDialog(null);
  };

  const deleteHandler = async (id) => {
    try {
      if (!id) {
        toast.error("ID is required to delete.");
        return;
      }
      await API.delete(`restaurant/floors/${id}`);
      onRefresh();
      toast.success('Deleted successfully')
    } catch (error) {
      toast.error(error.message || "Something went wrong!.");
    } finally {
      closeDeleteDialog();
    }
  };

  const handleToggle = async(id) => {
    try {
      const response = await API.put(
        `restaurant/floors/${id}/update-status`
      );
      onRefresh();
      toast.success('Status updated successfully')
    } catch (error) {    
      return (
        error.response?.data || {
          status: "failure",
          message: "Something went wrong.",
        }
      );
    }
  }

  return (
    <>
      <Table className="w-full">
        <TableHeader>
          <TableRow>
            <TableHead className="w-[100px]">No</TableHead>
            <TableHead>Floor</TableHead>
            <TableHead>Status</TableHead>
            <TableHead className="text-right">Action</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data && data?.length > 0 ? (
            data?.map((item, index) => (
              <TableRow key={index}>
                <TableCell className="font-medium">{index +1}</TableCell>
                <TableCell>{item?.name}</TableCell>
                <TableCell>
                  <Switch 
                    checked={item?.status === 'active'} 
                    disabled={!hasPermission("back_office.settings.floor_status_toggle")}
                    onClick={()=> handleToggle(item?.id)}
                  />
                </TableCell>
                <TableCell className="text-right justify-end flex gap-2 items-center">
                  <div className="flex items-center gap-2 h-8">
                    {hasPermission("back_office.settings.update_floor") && (
                      <span className="cursor-pointer">
                        <PenLine
                          onClick={() => {
                            setItemsDialog(item);
                            setFormType('update')
                            setIsSingleVoucherModalOpen(true)
                          }}
                          className="text-cyellow"
                          size={18}
                        />
                      </span>
                    )}

                    {hasPermission("back_office.settings.floor_delete") && (
                      <span>
                        <Trash2
                          onClick={() => {
                            setDeleteDialog(true);
                            setItemsDialog(item);
                          }}
                          className="text-cred cursor-pointer"
                          size={18}
                        />
                      </span>
                    )}
                  </div>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={8} className="text-center">
                No data available
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
      <AddEditFloor 
        isOpen={isSingleVoucherModalOpen}
        onClose={closeSingleVoucher}
        formType={formType}
        itemsDialog={itemsDialog}
        onRefresh={onRefresh}
      />
      <DeleteConfirmDialog
        isLoading={deleteLoading}
        isOpen={deleteDialog}
        onClose={closeDeleteDialog}
        onConfirm={() => {
          deleteHandler(itemsDialog.id);
        }}
      />
    </>
  );
}

export default FloorList;
